import ctaImg1 from 'website/assets/shop-finance-image.png'
import ctaImg2 from 'website/assets/woman-enjoying-her-financially-independence-while-buying-car.png'

const assets: Record<string, string> = {
  ctaImg1,
  ctaImg2
}

export default assets
